import TableHelperData from "./tableHelperData";

export default class TableManager {
  public static readonly IdRoadHelperColumnName: string = "IDRoad_Helper";
  public static readonly IdSegmentHelperColumnName: string = "IDSegment_Helper";
  public static readonly IdSessionHelperColumnName: string = "IDSession_Helper";
  public static readonly StartDistanceHelperColumnName: string =
    "StartDistance_Helper";
  public static readonly EndDistanceHelperColumnName: string =
    "EndDistance_Helper";
  public static readonly StartChainageHelperColumnName: string =
    "StartChainage_Helper";
  public static readonly EndChainageHelperColumnName: string =
    "EndChainage_Helper";
  public static readonly IdRecordHelperColumnName: string = "IDRecord_Helper"; // Some old databases don't have this
  public static readonly RoadNameHelperColumnName: string = "RoadName_Helper";

  private itemsCount: number = 0;
  private items: any[] = [];

  public init(itemsCount: number) {
    this.itemsCount = itemsCount;

    // console.log("itemsCount", this.itemsCount);

    this.items = [];
    for (let i = 0; i < itemsCount; i++) {
      this.items[i] = {};
    }
  }

  public addItems(addItems: any[], startIndex: number, stopIndex: number) {
    for (let index = startIndex; index <= stopIndex; index++) {
      this.items[index] = addItems[index - startIndex];
    }
  }

  public clearItems() {
    this.itemsCount = 0;
    this.items = [];
  }

  public hasItems() {
    return this.itemsCount !== 0;
  }

  public getItems = (index: number) => {
    return this.items[index];
  };

  public getItemIndex(
    idRoad: number,
    idSession: number,
    distance: number
  ): number {
    let index = -1;

    // console.log("getItemIndex-currentItems", this.items);

    for (let i = 0; i < this.itemsCount; i++) {
      const isItemLoaded = !!this.items[i];
      if (!isItemLoaded) {
        continue;
      }

      const tableHelperData = this.getTableHelperData(this.items[i]);
      if (
        idRoad === tableHelperData.idRoad &&
        idSession === tableHelperData.idSession &&
        distance >= tableHelperData.startDistance &&
        distance <= tableHelperData.endDistance
      ) {
        index = i;

        // console.log(
        //   "index-found",
        //   i,
        //   index,
        //   idRoad,
        //   idSegment,
        //   idSession,
        //   distance,
        //   tableHelperData.startDistance,
        //   tableHelperData.endDistance
        // );

        break;
      }
    }

    // console.log("getItemIndex-index", index);

    return index;
  }

  public getTableHelperData(item: any): TableHelperData {
    const tableHelperData = new TableHelperData();
    tableHelperData.idRoad = item[TableManager.IdRoadHelperColumnName];
    tableHelperData.idSegment = item[TableManager.IdSegmentHelperColumnName];
    tableHelperData.idSession = item[TableManager.IdSessionHelperColumnName];
    tableHelperData.startDistance =
      item[TableManager.StartDistanceHelperColumnName];
    tableHelperData.endDistance =
      item[TableManager.EndDistanceHelperColumnName];
    tableHelperData.startChainage =
      item[TableManager.StartChainageHelperColumnName];
    tableHelperData.endChainage =
      item[TableManager.EndChainageHelperColumnName];
    return tableHelperData;
  }

  public getHelperColumnNames(): string[] {
    return [
      TableManager.IdRoadHelperColumnName,
      TableManager.IdSegmentHelperColumnName,
      TableManager.IdSessionHelperColumnName,
      TableManager.StartDistanceHelperColumnName,
      TableManager.EndDistanceHelperColumnName,
      TableManager.StartChainageHelperColumnName,
      TableManager.EndChainageHelperColumnName,
    ];
  }
}
